import {useCallback, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricGreetingCard/reducers/fabricDesign/constants';
import {selectEnvelopeId} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {selectEnvelopes} from '~/CreateFabricGreetingCard/reducers/fabricTemplate/selectors';

export const useEnvelope = () => {
  const dispatch = useDispatch();
  const envelopes = useSelector(selectEnvelopes);
  const envelopeId = useSelector(selectEnvelopeId);

  const onEnvelopeChange = useCallback(
    (icon) => {
      const selected = envelopes.find((envelope) => envelope.icon === icon);
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {envelopeId: selected.id, premiumFeaturesPristine: false},
      });
    },
    [envelopes, dispatch]
  );

  const envelopeIcons = useMemo(() => envelopes.map(({icon}) => icon), [envelopes]);

  const selectedEnvelope = useMemo(
    () => envelopes.find(({id}) => id === envelopeId),
    [envelopes, envelopeId]
  );

  return {onEnvelopeChange, envelopeIcons, selectedEnvelope};
};
